module.exports = __webpack_public_path__ + "fonts/deposit-guide-1.5a551b14s.png";